import { actions, roles } from '../constants';

export const section = {
  addInternshipRequest: 'addInternshipRequest',
  acceptInternshipRequest: 'acceptInternshipRequest',
  deleteInternshipRequest: 'deleteInternshipRequest',
};

export default (role, can, rules) => {
  if (role === roles.Applicant) {
    can(actions.see, section.addInternshipRequest);
    can(actions.see, section.deleteInternshipRequest);
  }
  if (role === roles.Teacher) {
    can(actions.see, section.acceptInternshipRequest);
    can(actions.see, section.deleteInternshipRequest);
  }
  return rules;
};
